import React from "react";
import { inject, observer } from "mobx-react";

import { FormGroup, Radio } from "react-bootstrap";
import Select from "react-select";

import "./Profile.scss";

@inject("userStore", "changeSingleFieldValueModalStore", "searchStore")
@observer
class Profile extends React.Component {
  handleProfileChange = (profile) => {
    const {
      getCubeTypeOptions,
      setSelectedUserProfile,
      setSelectedCubeTypes,
    } = this.props.searchStore;
    setSelectedUserProfile(profile);
    if (profile.id === "custom") {
      setSelectedCubeTypes(getCubeTypeOptions.map((cto) => cto.value));
    } else {
      setSelectedCubeTypes(profile.cubeTypes);
    }
    this.showWarning();
    document.querySelector(".main-content").scrollTop = 0;
  };

  handleCubeTypeChange = (options) => {
    const { setSelectedCubeTypes } = this.props.searchStore;
    const selectedCubeTypes = options.map((option) => option.value);
    setSelectedCubeTypes(selectedCubeTypes);
    this.showWarning();
  };

  showWarning = () => {
    const { pathName } = this.props;
    const { setUserProfileChanged } = this.props.searchStore;
    if (pathName.includes("/view") || pathName.includes("/search") || pathName.includes("/multisearch")) {
      setUserProfileChanged(true);
    }
  };

  render() {
    const {
      getCubeTypeOptions,
      getUserProfiles,
      getSelectedCubeTypes,
      getSelectedUserProfile,
    } = this.props.searchStore;
    return (
      <div className="sdd-profile-container">
        <div>
          {getUserProfiles
            ? getUserProfiles.map((up, index) => (
                <FormGroup key={`profile-${index}`}>
                  <Radio
                    name="user-profile"
                    onChange={() => this.handleProfileChange(up)}
                    checked={
                      getSelectedUserProfile &&
                      getSelectedUserProfile.id === up.id
                    }
                  >
                    {up.label}
                  </Radio>
                </FormGroup>
              ))
            : null}
        </div>
        <div>
          <label>Cube Types: </label>
          <Select
            closeMenuOnSelect={false}
            onChange={(options) => this.handleCubeTypeChange(options)}
            options={getCubeTypeOptions}
            isClearable={true}
            placeholder={
              getSelectedUserProfile && getSelectedUserProfile.id === "custom"
                ? "Cube Types"
                : "Cube Types (All)"
            }
            value={getCubeTypeOptions.filter(option => getSelectedCubeTypes.includes(option.value))}
            isMulti
            isDisabled={
              getSelectedUserProfile && getSelectedUserProfile.id !== "custom"
            }
          />
        </div>
        {/* <div>
          <ControlLabel>Current Username:</ControlLabel>
          <FormControl readOnly={true} value={get_obj_userData.actor.name} />
          <ControlLabel>New Username:</ControlLabel>
          <FormControl
            onChange={(e) => {
              changeFieldValue(e.target.value);
            }}
            value={getModalData.newFieldValue}
          />
          <Button
            bsStyle="primary"
            onClick={() => {
              setOrchestrationType("Actor");
              saveNewFieldValue();
              changeFieldValue("");
            }}
            disabled={!getModalData.newFieldValue}
          >
            Save
          </Button>
        </div> */}
      </div>
    );
  }
}

export default Profile;
